module.exports = __webpack_public_path__ + "static/media/sr.07abdb38.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sr.svg
// module id = 2213
// module chunks = 0